import React from "react";
import "./stylesheets/app.scss";
import Button from "./components/Button";
import { BrowserRouter, Route, Routes } from "react-router";
import Label from "./components/Label";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Homepage from "./pages/Homepage";
import Login from "./pages/Login";
import { NotificationProvider } from "./contexts/NotificationContext";
import Booking from "./pages/Booking";
import Menu from "./pages/Menu";
import Events from "./pages/Events";
import Contact from "./pages/Contact";
import ScrollToTop from "./components/ScrollToTop";

function App() {
	return (
		<NotificationProvider>
			<BrowserRouter>
				<ScrollToTop />
				<Routes>
					<Route path="/" element={<Homepage />} />
					<Route path="/login" element={<Login />} />
					<Route path="/booking" element={<Booking />} />
					<Route path="/menu" element={<Menu />} />
					<Route path="/events" element={<Events />} />
					<Route path="/contact" element={<Contact />} />
				</Routes>
			</BrowserRouter>
		</NotificationProvider>
	);
}

export default App;
